'use client';

import Link from '@eliadmin/core/src/components/link';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../ui/heading';
import { Paragraph } from '../ui/paragraph';
import { Button } from '../ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import Image from '@eliadmin/core/src/components/image/image-wrapped';

export function CategoryPromotion({
  image,
  description,
  name,
}: {
  image: string;
  description: string;
  name: string;
}) {
  const { t } = useTranslations();

  return (
    <section
      className={cn(
        'custom-section',
        'grid grid-cols-1 gap-12 p-6 py-12 sm:grid-cols-2 sm:gap-0 sm:py-6',
        'ea-category-promotion',
      )}
    >
      <div className="col-span-1 flex w-full items-center justify-end pr-0 md:pr-12 lg:pr-24 xl:pl-0">
        <div className="flex w-full flex-col items-start justify-start gap-6 sm:max-w-[504px]">
          <Heading title={name} className={{ title: 'uppercase text-white' }} />
          <Paragraph
            className={cn('w-full', 'ea-category-promotion__description')}
            innerHtml={description}
            color="white"
            size="lg"
          />
          <Button asChild variant={'white'} className="w-full sm:w-fit">
            <Link prefetch={false} href={ROUTES.CONTACT()}>
              {t('text3392')}
            </Link>
          </Button>
        </div>
      </div>
      <div className="relative col-span-1 h-[264px] w-full overflow-hidden rounded-[4px] pl-6 sm:h-[600px]">
        <Image
          src={image}
          alt={name}
          width={0}
          height={0}
          className="absolute inset-0 z-0 h-full w-full object-cover object-center"
          sizes="100vw"
        />
      </div>
    </section>
  );
}
